<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                Sukurti naują įrangos pavadinimą/poziciją
            </div>
            <div class="card-body">

                <div class="form-row my-1">
                    <div class="col-12 col-md-4">
                        <!--<input type="text" id="name" class="form-control" @keydown="remove_invalid" placeholder="Pavadinimas" v-model="new_row.name">-->
                        <!--<select class="form-control" id="name"  @change="remove_invalid" name="" v-model="new_row.name">-->
                            <!--<option value="">Pavadinimas ...</option>-->
                            <!--<option v-for="n in names" :value="n.code">{{ n.name }}</option>-->
                        <!--</select>-->

                        <v-select v-if="names" class="vue-select2s" id="eq_id" name="name"
                                  :options="names" label="name"
                                  :model.sync="eq_selected"
                                  v-model="eq_selected"
                                  :searchable="true" language="en-US">
                        </v-select>
                    </div>
                    <div class="col-12 col-md-4">
                        <input type="text" id="price" class="form-control" @keydown="remove_invalid" placeholder="Kaina € be PVM" @keyup="delete_comma" v-model="new_row.price">
                    </div>
                    <div class="col-12 col-md-4">
                        <select class="form-control" id="type"  @change="remove_invalid" name="" v-model="new_row.equipment_type_id">
                            <option value="">Tipas ...</option>
                            <option v-for="t in types" :value="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row my-1">
                    <div class="col-12 col-md-4">
                        <input type="text" class="form-control" placeholder="Galia kW" @keyup="delete_comma" v-model="new_row.power">
                    </div>
                    <div class="col-12 col-md-4">
                        <input type="text" class="form-control" placeholder="Garantija met." v-model="new_row.warranty">
                    </div>
                    <div class="col-12 col-md-4">
                        <input type="text" class="form-control" placeholder="Efekt. garantija" v-model="new_row.efficiency_warranty">
                    </div>
                </div>

                <div class="form-row my-1">
                    <div class="col">

                        <input type="text" class="form-control" placeholder="Aprašymas" v-model="new_row.description">

                    </div>
                </div>

            </div>
            <div class="card-footer">
                <div class="col ">
                    <button @click="store_equipment" class="btn btn-outline-success ml-auto" :class="{ disabled: disabled_store_btn }" :disabled="disabled_store_btn">Įrašyti</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    export default {
        name: "NewEqiuipment",
        components:{
            vSelect,
        },
        data: function () {
            return {
                new_row: {
                    name: '',
                    ext_code: '',
                    price: '',
                    equipment_type_id: '',
                    description: '',
                    power: null,
                    warranty: null,
                    efficiency_warranty: null
                },
                types:'',
                names:'',
                table_eq:'',
                eq_selected: '',
                disabled_store_btn: false
            }
        },

        methods: {
            store_equipment() {
                let got_err = 0;
                this.disabled_store_btn = true;

                if (this.new_row.name === '') {
                    $('#name').addClass('is-invalid');
                    this.disabled_store_btn = false;
                    let got_err = 1;
                }
                if (this.new_row.price === '') {
                    $('#price').addClass('is-invalid');
                    this.disabled_store_btn = false;
                    let got_err = 1;
                }
                if (this.new_row.equipment_type_id < 1) {
                    $('#type').addClass('is-invalid');
                    this.disabled_store_btn = false;
                    let got_err = 1;
                }

                if (got_err === 1) {
                    this.disabled_store_btn = false;
                    return;
                }

                axios.post('store_equipment', this.new_row).then(res => {
                    console.log(res.data);
                    window.location.reload();
                })
            },
            delete_comma(e){
                $(e.target).val($(e.target).val().replace(',','.'));
            },

            remove_invalid(e) {
                $(e.target).removeClass('is-invalid');
            }

        },

        watch: {
            eq_selected: function (val) {
                this.new_row.description = this.eq_selected.description;
                this.new_row.power = this.eq_selected.power;
                this.new_row.price = this.eq_selected.price;
                this.new_row.name = this.eq_selected.name;
                this.new_row.ext_code = this.eq_selected.code;

                // var table_eq = $('#table_eq').DataTable({
                //
                // });
                if(this.eq_selected){
                    this.table_eq.search(this.eq_selected.code).draw();
                }

            },
        },

            mounted() {
            axios.get('/get_equipment_types').then(res => {
                this.types = res.data;
            });

            axios.get('/get_equipment_names').then(res => {
                this.names = res.data;
            });

                this.table_eq = $('#table_eq').DataTable({
                    "lengthMenu": [50, 150],
                    "orderMulti": false,
                    "autoWidth": false,
                    "ordering": false,
                    "stateSave": false,
                    "bPaginate": false,
                });
                this.table_eq.columns.adjust().draw();
                //on eq search
                // this.table_eq.on('search.dt', function () {
                //     const url = new URL(window.location.href);
                //     url.searchParams.set('filter', this.table_eq.search());
                //     window.history.replaceState(null, null, url); // or pushState
                //     $('.copy_filter').text('Copy');
                // });
        }
    }
</script>

<style scoped>

</style>